export default __webpack_public_path__ + "static/media/profile.3d6635b7.jpg";